import * as yup from 'yup'

export const SchemaPasswordReset = yup.object().shape({
    email: yup.string().required("O email é obrigatório"),
    password:yup.string().required("A senha é obrigatória"),
    password_confirmation: yup
    .string()
    .oneOf([yup.ref("password")], "Senhas não coincidem")
    .required("Confirme sua senha")
})